import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAverageCycleDuration = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_2616",
	"data-name": "Group 2616",
	xmlns: "http://www.w3.org/2000/svg",
	width: 66.19,
	height: 40.802,
	viewBox: "0 0 66.19 40.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			id: "Group_100",
			"data-name": "Group 100",
			transform: "translate(0 0)",
			opacity: 0,
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_241",
				"data-name": "Path 241",
				d: "M264.219,72.526h-66.19V48.659h66.19Zm-65.712-.367h65.233V49.026H198.507Z",
				transform: "translate(-198.029 -48.659)",
				fill: "current"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_101",
			"data-name": "Group 101",
			transform: "translate(5.655 10.746)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_242",
				"data-name": "Path 242",
				d: "M213.439,77.944",
				transform: "translate(-213.439 -77.944)",
				fill: "none",
				stroke: "#040505",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 4
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_243",
			"data-name": "Path 243",
			d: "M220.372,60.441a1.585,1.585,0,0,0-1.767.174c-.214.17-.456.368-.714.58a15.944,15.944,0,0,1-3.034,2.162c-1.067.36-4.141.987-5.413,1.241a.872.872,0,0,0-.451.247c-.134-.109-.271-.229-.414-.371-.923-.917-3.179-3.207-3.18-3.208l-1.045,1.03s2.265,2.3,3.191,3.219a6.569,6.569,0,0,0,1.769,1.282l.041.058a2.335,2.335,0,0,1-.863,1.124,3,3,0,0,1-1.181.339h0c-.032,0-.062.015-.094.02-.153-.219-.356-.49-.621-.843a21.222,21.222,0,0,0-3.5-3.1.734.734,0,0,0-.856,1.192,19.5,19.5,0,0,1,3.186,2.784c.345.461.538.731.645.888a1.48,1.48,0,0,0-.048.941,7.256,7.256,0,0,0,.511,1.282,13.283,13.283,0,0,0,1.341,2.155,4.371,4.371,0,0,0,.559,1.548.735.735,0,0,0,.55.412,2.223,2.223,0,0,0,.332.021,4.923,4.923,0,0,0,3.129-1.294c1.577-1.324,6.213-6.092,6.431-6.318.1-.107,2.332-2.644,2.554-4.889A2.6,2.6,0,0,0,220.372,60.441Zm-.406,2.535c-.146,1.469-1.63,3.428-2.168,4.035-.048.049-4.78,4.917-6.3,6.193a3.8,3.8,0,0,1-1.932.934c-.1-.231-.183-.437-.218-.546l.011-.109a.738.738,0,0,0-.179-.557,11.03,11.03,0,0,1-1.338-2.1,5.139,5.139,0,0,1-.4-1.037c.006-.009.011-.01.013-.01a4.346,4.346,0,0,0,1.776-.53,4.011,4.011,0,0,0,1.661-2.353.736.736,0,0,0-.138-.633c-.094-.119-.19-.25-.274-.376,1.641-.334,3.9-.819,4.852-1.14a14.532,14.532,0,0,0,3.5-2.418c.252-.207.489-.4.7-.566.086-.069.127-.046.15-.033C219.83,61.817,220.041,62.221,219.966,62.976Z",
			transform: "translate(-200.499 -55.996)",
			fill: "current",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_244",
			"data-name": "Path 244",
			d: "M294.106,60.441a1.584,1.584,0,0,0-1.766.174c-.213.17-.455.368-.713.579a15.946,15.946,0,0,1-3.035,2.163c-1.067.36-4.141.987-5.413,1.241a.874.874,0,0,0-.451.247c-.133-.11-.271-.229-.414-.371-.923-.917-3.179-3.207-3.18-3.208l-1.046,1.03s2.265,2.3,3.191,3.219a6.58,6.58,0,0,0,1.769,1.282l.04.058a2.336,2.336,0,0,1-.863,1.124,3,3,0,0,1-1.18.339h0c-.032,0-.062.014-.094.019-.153-.219-.356-.49-.621-.843a21.226,21.226,0,0,0-3.5-3.1.734.734,0,0,0-.857,1.192,19.513,19.513,0,0,1,3.186,2.784c.345.461.538.731.645.888a1.482,1.482,0,0,0-.048.941,7.283,7.283,0,0,0,.511,1.282,13.286,13.286,0,0,0,1.341,2.155,4.376,4.376,0,0,0,.559,1.548.734.734,0,0,0,.55.412,2.213,2.213,0,0,0,.331.021,4.922,4.922,0,0,0,3.129-1.294c1.577-1.324,6.213-6.092,6.432-6.318.1-.107,2.331-2.644,2.554-4.889A2.6,2.6,0,0,0,294.106,60.441Zm-.406,2.535c-.145,1.469-1.63,3.428-2.168,4.035-.048.049-4.78,4.917-6.3,6.193a3.8,3.8,0,0,1-1.932.934c-.1-.231-.183-.437-.218-.546l.011-.109a.739.739,0,0,0-.179-.558,10.947,10.947,0,0,1-1.339-2.1,5.108,5.108,0,0,1-.4-1.037c.006-.009.011-.01.013-.01a4.344,4.344,0,0,0,1.776-.53,4.011,4.011,0,0,0,1.661-2.353.735.735,0,0,0-.138-.634c-.093-.117-.189-.249-.274-.376,1.641-.334,3.9-.819,4.852-1.14a14.557,14.557,0,0,0,3.5-2.418c.252-.207.488-.4.7-.566.087-.069.126-.046.151-.033C293.564,61.817,293.775,62.221,293.7,62.975Z",
			transform: "translate(-247.176 -55.996)",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_245",
			"data-name": "Path 245",
			d: "M254.25,95.781c.009-.023.015-.047.022-.07s.015-.044.02-.067a.719.719,0,0,0,.014-.14v0h0a.729.729,0,0,0-.014-.144c0-.021-.012-.039-.018-.059a.682.682,0,0,0-.024-.079c-.01-.022-.022-.043-.034-.064s-.021-.042-.034-.062a.758.758,0,0,0-.084-.1l-.007-.008-1.954-1.955a.734.734,0,0,0-1.038,1.038l.7.7H235.694a.734.734,0,0,0,0,1.468H251.8l-.7.7a.734.734,0,1,0,1.038,1.038l1.953-1.953a.73.73,0,0,0,.093-.114c.011-.016.018-.033.027-.05A.716.716,0,0,0,254.25,95.781Z",
			transform: "translate(-221.408 -76.61)",
			fill: "current"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_102",
			"data-name": "Group 102",
			transform: "translate(16.113 26.207)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Path_246",
				"data-name": "Path 246",
				d: "M341.62,67.044V65.823a1.549,1.549,0,0,0-1.547-1.547h-2a1.549,1.549,0,0,0-1.547,1.547v1.217a6.165,6.165,0,0,0-.947.53.734.734,0,0,0,.83,1.211,4.726,4.726,0,1,1-1.992,4.645l.751.751a.734.734,0,1,0,1.038-1.038l-1.954-1.954a.734.734,0,0,0-1.038,0l-1.954,1.954a.734.734,0,1,0,1.038,1.038l.652-.652a6.188,6.188,0,1,0,8.676-6.48Zm-3.631-.457v-.764a.08.08,0,0,1,.079-.08h2a.08.08,0,0,1,.079.08v.766a5.94,5.94,0,0,0-2.163,0Z",
				transform: "translate(-331.038 -64.276)",
				fill: "current"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Path_247",
				"data-name": "Path 247",
				d: "M351.661,76.259a.734.734,0,0,0-.734.734v3.273a.734.734,0,0,0,.215.519l1.762,1.762a.734.734,0,1,0,1.038-1.038l-1.547-1.547V76.993A.734.734,0,0,0,351.661,76.259Z",
				transform: "translate(-343.629 -71.862)",
				fill: "current"
			})]
		})
	]
});
const ForwardRef = forwardRef(SvgAverageCycleDuration);
export { ForwardRef as ReactComponent };
